import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M9 18h12v-2H9v2zM3 6v2h18V6H3zm6 7h12v-2H9v2z"
}), 'Segment');